import http from './http'

const getUsageReportCredits = params => {
    return http({
        method: 'GET',
        url: `/reports/credits?date=${params.date}${params.to ? "&to=" + params.to : ""}${params.from ? "&from=" + params.from : ""}`,
    })
}

const getUsageReportCreditsService = params => {
    return http({
        method: 'GET',
        url: `/reports/credits/user?&offset=${params.offset}&limit=${params.limit}${params.type ? "&type=" + params.type : ""}${params.search ? "&search=" + params.search : ""}&date=${params.date}${params.from ? "&from=" + params.from : ""}${params.to ? "&to=" + params.to : ""}`,
    })
}
const checkAiCreditsStatus = (type) => {
    return http({
        method: 'GET',
        url: `/credits/check?service=${type}`,
    })
}

const purchaseAiCredits = (data) => {
    return http({
        method: 'POST',
        url: '/credits/purchase',
        data
    })
}

export {
    getUsageReportCredits,
    getUsageReportCreditsService,
    checkAiCreditsStatus,
    purchaseAiCredits
}
